import store from "../../../store";
import didi_export from './didi_export.vue';

window.didi_export =  new Vue({
    store,
    el: 'div#didi_export',

    name : "didi_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        didi_export,
    }
});
